const ipTmp = [0, 0, 0, 0];
const ipPart = "(25[0-5]|2[0-4]\\d|[01]?\\d?\\d)";
const ipMatchRex = new RegExp("^" + [ipPart, ipPart, ipPart, ipPart].join("\\."));
const ipParseRex = new RegExp(ipMatchRex.source + "$");
const ipMinLength = 7;
const ipMaxLength = 15;

const ipParse = function(match) {
    let result = 0;
    for (let i = 0; i < 4; i++) {
        result = result * 256 + Number(match[i + 1]);
    }
    return result;
};

const ipFormat = function(_ipNum) {
    let ipNum = _ipNum;
    for (let i = 3; i >= 0; i--) {
        ipTmp[i] = ipNum & 0xff;
        ipNum >>= 8;
    }
    return ipTmp.join(".");
};

const IPv4 = function(ipNum) {
    this._num = ipNum;
};

IPv4.prototype = {
    cmp: function(other) {
        const num = this._num;
        const otherNum = other._num;

        if (num === otherNum) {
            return 0;
        }
        return num < otherNum ? -1 : 1;
    },

    format: function() {
        return ipFormat(this._num);
    }
};

const cidrMatchRex = new RegExp(ipMatchRex.source + "(?:/(3[012]|[012]?\\d))?");
const cidrParseRex = new RegExp(cidrMatchRex.source + "$");
const cidrMinLength = ipMinLength;
const cidrMaxLength = ipMaxLength + 3;

const IPv4CIDR = function(ipNum, bits) {
    const mask = Math.pow(2, 32 - bits);
    const first = ipNum - (ipNum % mask);

    this.first = first;
    this.last = first + (mask - 1);

    this._bits = bits;
};

const cidrParse = function(match) {
    const ipNum = ipParse(match);
    const bits = match[5] === void 0 ? 32 : Number(match[5]);
    return new IPv4CIDR(ipNum, bits);
};

IPv4CIDR.prototype = {
    contains: function(cidr) {
        return this.first <= cidr.first && cidr.last <= this.last;
    },

    format: function() {
        return ipFormat(this.first) + "/" + this._bits;
    }
};

export default {
    matchIP: function(string) {
        const length = string.length;
        if (length < ipMinLength) {
            return null;
        }

        const match = string.match(ipMatchRex);
        if (match === null) {
            return null;
        }

        return {
            "match": new IPv4(ipParse(match)),
            "tail": string.slice(match[0].length)
        };
    },

    parseIP: function(string) {
        const length = string.length;
        if (length < ipMinLength || length > ipMaxLength) {
            return null;
        }

        const match = string.match(ipParseRex);
        return match === null ? null : new IPv4(ipParse(match));
    },

    matchCIDR: function(string) {
        const length = string.length;
        if (length < cidrMinLength) {
            return null;
        }

        const match = string.match(cidrMatchRex);
        if (match === null) {
            return null;
        }

        return {
            "match": cidrParse(match),
            "tail": string.slice(match[0].length)
        };
    },

    parseCIDR: function(string) {
        const length = string.length;
        if (length < cidrMinLength || length > cidrMaxLength) {
            return null;
        }

        const match = string.match(cidrParseRex);
        return match === null ? null : cidrParse(match);
    }
};



// WEBPACK FOOTER //
// ./src/abusesa-js/formats/ipv4.js